import * as React from "react";
import apiClient from "@/api-client";
import { Button } from "@mui/material";
import { toast } from "sonner";

import { appHref } from "@/lib/platform";

/** Cross-account request pages must select the owner before opening a tenant-scoped editor. */
export function AccountPageLink({
	accountId,
	path,
	children,
}: {
	accountId?: string | null;
	path: string;
	children: React.ReactNode;
}) {
	const [opening, setOpening] = React.useState(false);
	return (
		<Button
			variant="text"
			disabled={opening || !accountId}
			sx={{ alignSelf: "start", px: 0 }}
			onClick={async () => {
				setOpening(true);
				try {
					await apiClient.post(`/accounts/${accountId}/use`, {});
					// A full navigation also discards cached run IDs belonging to the previous account.
					globalThis.location.assign(appHref(path));
				} catch {
					setOpening(false);
					toast.error("Could not open this account. Please retry.");
				}
			}}
		>
			{children}
		</Button>
	);
}
